export enum BadgeType {
  Success = 'Success',
  Fail = 'Fail',
  Info = 'Info',
  Warning = 'Warning',
  Refund = 'Refund',
  Default = 'Default',
}
